import { Skeleton } from '@/components/ui/skeleton';
import iconUrl from '@/assets/brand/zafroi_logo.png';
import { cn } from '@/lib/utils';

export function LoadingRows({ rows = 6, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="grid gap-3 px-3 py-2.5" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
          {Array.from({ length: cols }).map((__, c) => (
            <Skeleton key={c} className={cn('h-4', c === 0 ? 'w-24' : 'w-16')} />
          ))}
        </div>
      ))}
    </div>
  );
}

export function LoadingCard({ className }: { className?: string }) {
  return (
    <div className={cn('rounded-lg border p-5 shadow-elev-1', className)}>
      <Skeleton className="h-4 w-32" />
      <Skeleton className="mt-3 h-8 w-24" />
      <Skeleton className="mt-2 h-3 w-40" />
    </div>
  );
}

export function PageLoading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20">
      <img src={iconUrl} alt="" aria-hidden="true" className="h-12 w-12 animate-pulse" draggable={false} />
      <div className="text-sm text-muted-foreground">{label}</div>
    </div>
  );
}
